import BaseModal from './BaseModal.jsx'
import { ModalContentWrapper } from './BaseModal.styles'
export default BaseModal
export { ModalContentWrapper }
